import React, {Component} from "react";
import {
    Table
} from "reactstrap";

import {NotificationManager} from "react-notifications";
import Registry from "../../../Utils/Registry";
import EnterpriseInvoicesTableLine from "./Table/Line";
import Variables from "../../../Utils/Variables";
import TYCheckBox from "../../TYCheckBox";

class EnterpriseInvoicesTable extends Component {
    constructor(props) {
        super(props);

        this.api = Registry.registered("api");
        this.user = Registry.observe(this, "user", user => {
            this.user = user;
        });

        this.state = {
            information: false,
            invoices: [],
            allToggle: false
        };

        this.onInvoiceSelected = this.onInvoiceSelected.bind(this);
    }

    onInvoiceSelected(order, selected = true) {
        let array = this.state.invoices;
        let index = array.indexOf(order);

        if(selected && index === -1)
            this.state.invoices.push(order);
        else if(index > -1)
            array.splice(index, 1);

        this.setState({invoices: array}, () => {
            this.props.onInvoicesSelected(array);
        });
    }

    toggleMasterCheckbox = state => {
        let array = [];
        if(state){
            for(let i of this.props.invoices)
                array.push(i);
        }
		this.setState({invoices: array}, () => {
			this.props.onInvoicesSelected(array);
		});
    };

    requireInvoice(invoice) {
        if(this.user){
            let url = "?invoices_numbers=" + invoice.number + "&user_id=" + this.user.business_id + "&is_business=1";
            this.api
                .download("/orders/invoices/download" + url, 'Tankyou-' + invoice.number + '.pdf')
                .catch(error => {
                    NotificationManager.error("Impossible de recuperer la facture");
                });
        }
        else
            NotificationManager.error("Impossible de générer les factures");
    }

    render() {
        return (
            <div>
                <div className="ty-block">
                    <Table responsive striped hover className="pointer spacing-table marg-b-0 f-12">
                        <thead>
                        <tr className="ty-table-header">
                            <th className="wp-10">N&deg;</th>
                            <th className="wp-10">Date</th>
                            <th className="w-15">Volume</th>
                            <th className="w-15">Prix HT</th>
                            <th className="w-15">Prix TTC</th>
                            <th className="">Pay&eacute;</th>
                            <th className="_w-50"> </th>
                            <th className="_w-50"><TYCheckBox onToggle={this.toggleMasterCheckbox} /></th>
                        </tr>
                        </thead>

                        <tbody>
                            {
                                this.props.loading ?
                                    <tr><td colSpan="8" className="center border-0 bg-white"><i className="icon icon-loading animated spin infinite f-20" /></td></tr>
                                    :
                                    this.props.invoices.length ? 
                                        this.props.invoices.map((invoice, i) => {
                                            return (
                                                <EnterpriseInvoicesTableLine
                                                    key={i}
                                                    invoice={invoice}
                                                    downloadInvoice={() => { this.requireInvoice(invoice); }}
                                                    onInvoiceSelected={this.onInvoiceSelected}
                                                    selected={this.state.invoices.indexOf(invoice) > -1}
                                                />
                                            )
                                        })
                                        :
                                        <tr><td colSpan="8" className="center border-0 bg-white gray_dark">Aucune factures</td></tr>
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
        )
    }
}

EnterpriseInvoicesTable.defaultProps = {
    invoices: [],
    doMultiSelect: false,
    onInvoicesSelected: (invoices) => {},
    loading: false
};

export default EnterpriseInvoicesTable;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Invoices/InvoicesTable.js